import { Component, OnInit, Input, OnChanges, SimpleChanges, ElementRef, HostBinding } from '@angular/core';

@Component({
  selector: 'content-window',
  templateUrl: './content-window.component.html',
  styleUrls: ['./content-window.component.less']
})
export class ContentWindowComponent implements OnInit {

  @Input() name: string = "No title";
  @Input() desc: string = "";

  @HostBinding('style.position') @Input() mode: 'relative' | 'fixed' | 'absolute' = "relative";
  @Input() placement: 'bottom' | 'right' | 'left' | 'top' | 'bottom,right' | 'top,right' | '' = "";

  constructor(private eleRef: ElementRef) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.placement) {
      var placements = this.placement.split(",");

      for (var plm of placements) {
          this.eleRef.nativeElement.style[plm] = "20px";
      }

    }
  }

}
